module.exports = __webpack_public_path__ + "img/strawberry01_300px.9790d2ed.jpg";